import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import {
  getAll_1 as getAllEmployeesFn,
  GetAll_1$Params,
} from '../../api/fn/employee-management/get-all-1';
import { catchError, map, Observable, of } from 'rxjs';
import { Employee } from '../../api/models';
import {
  getByOrganizationId_4 as getEmployeesByOrganizationIdFn,
  GetByOrganizationId_4$Params,
} from '../../api/fn/employee-management/get-by-organization-id-4';
import {
  createEmployee as createEmployeeFn,
  CreateEmployee$Params,
} from '../../api/fn/employee-management/create-employee';
import {
  deleteEmployee as deleteEmployeeFn,
  DeleteEmployee$Params,
} from '../../api/fn/employee-management/delete-employee';
import {
  deleteEmployees as deleteEmployeesFn,
  DeleteEmployees$Params,
} from '../../api/fn/employee-management/delete-employees';
import {
  updateEmployee,
  UpdateEmployee$Params,
} from '../../api/fn/employee-management/update-employee';

@Injectable({ providedIn: 'root' })
export class EmployeeService {
  constructor(private apiService: ApiService) {}

  getAllEmployees(): Observable<Employee[] | undefined> {
    return this.apiService
      .invoke(getAllEmployeesFn)
      .pipe(map((response) => response.employees));
  }

  getEmployeesByOrganization(params: GetByOrganizationId_4$Params) {
    return this.apiService
      .invoke(getEmployeesByOrganizationIdFn, params)
      .pipe(map((response) => response.employees));
  }

  createEmployee(params: CreateEmployee$Params): Observable<Employee> {
    return this.apiService.invoke(createEmployeeFn, params);
  }

  updateEmployee(params: UpdateEmployee$Params): Observable<boolean> {
    return this.apiService.invoke(updateEmployee, params).pipe(
      map(() => true),
      catchError((error) => of(false))
    );
  }

  deleteEmployee(params: DeleteEmployee$Params): Observable<boolean> {
    return this.apiService.invoke(deleteEmployeeFn, params).pipe(
      map(() => true),
      catchError((error) => of(false))
    );
  }

  deleteAllEmployeesInOrganization(params: DeleteEmployees$Params) {
    return this.apiService.invoke(deleteEmployeesFn, params);
  }
}
